import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevenurbaniaonrent() {



  const cardData = {
"keyword": "17 Seater Urbania on Rent in Pune",

"headingDescription":
  "Aaradhya Travels provides comfortable 17 Seater Urbania on Rent in Pune for weddings, corporate events, airport transfers, family trips, outstation tours, business travel, and luxury group transportation requirements. Our 17-seater Force Urbania vehicles feature premium pushback seats, air-conditioning, spacious interiors, luggage space, charging points, music systems, and experienced drivers familiar with Pune city routes and highways. We ensure safe, comfortable, and punctual travel with doorstep pickup services for local and outstation journeys across Pune.",

"topPlaces": [
{
"title": "Mumbai",
"description":
"Mumbai is the financial capital of India known for Marine Drive, Gateway of India, Juhu Beach, Bollywood, shopping streets, and vibrant city life. It is one of the most popular group travel destinations from Pune for corporate tours, shopping trips, and leisure outings."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station near Mumbai known for toy train rides, viewpoints, dense greenery, and cool weather. It is a peaceful weekend getaway for families and group travelers from Pune and Mumbai."
},
{
"title": "Alibaug",
"description":
"Alibaug is a coastal beach destination near Mumbai known for clean beaches, sea forts, water sports, and relaxed seaside atmosphere. It is a popular group tour destination for short trips from Pune."
},
{
"title": "Lonavala",
"description":
"Lonavala is a famous hill station near Mumbai and Pune known for waterfalls, caves, green valleys, and monsoon beauty. It is a highly visited weekend destination for group bus and Tempo Traveller trips."
},
{
"title": "Khandala",
"description":
"Khandala is known for scenic valleys, misty hills, and natural viewpoints. It is a short and relaxing getaway destination popular among families and group travelers from Mumbai and Pune."
},
{
"title": "Navi Mumbai",
"description":
"Navi Mumbai is a planned city known for clean infrastructure, parks, malls, and business hubs. It is commonly visited for corporate group travel, events, and city tours."
},
{
"title": "Elephanta Caves",
"description":
"Elephanta Caves are UNESCO World Heritage rock-cut caves located on an island near Mumbai known for ancient sculptures and historical significance. It is a popular heritage group tour destination."
},
{
"title": "Imagicaa Theme Park",
"description":
"Imagicaa is a large theme park near Mumbai offering rides, entertainment zones, and water parks. It is a popular destination for school trips, corporate outings, and family group tours."
},
{
"title": "Karjat",
"description":
"Karjat is a scenic green valley near Mumbai known for waterfalls, rivers, resorts, and adventure activities. It is widely chosen for weekend group trips and corporate outings."
},
{
"title": "Khopoli",
"description":
"Khopoli is known for industrial areas, waterfalls nearby, and proximity to Imagicaa theme park. It is a convenient stopover destination for group travel between Pune and Mumbai."
}
],



services: [
  {
    name: "17 Seater Urbania Traveller Pune",
    description: "17 seater Urbania traveller Pune service provides luxury transportation for family vacations, airport transfers, sightseeing tours, and group travel requirements. Spacious seating and premium interiors ensure comfortable journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient 17 seater Urbania traveller reservations."
  },
  {
    name: "17 Seater Urbania Hire in Pune",
    description: "17 seater Urbania hire in Pune service offers spacious transportation for weddings, business travel, office outings, and tourist journeys. Comfortable seating and smooth travel ensure pleasant journeys suitable for local and outstation passenger movement. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Flexible booking options allow convenient 17 seater Urbania hire reservations."
  },
  {
    name: "17 Seater Urbania Booking Pune",
    description: "17 seater Urbania booking Pune service provides dependable transportation for educational tours, family group travel, sightseeing trips, and airport transfers. Spacious seating and luggage capacity ensure comfortable journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient 17 seater Urbania booking reservations."
  },
  {
    name: "17 Seater Urbania Van Rental Pune",
    description: "17 seater Urbania van rental Pune service offers reliable transportation for family outings, corporate travel, airport pickups, and wedding group transportation. Spacious interiors and comfortable seating ensure smooth journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient Urbania van rental reservations."
  },
  {
    name: "17 Seater Luxury Urbania on Rent Pune",
    description: "17 seater luxury Urbania on rent Pune service provides premium transportation with elegant interiors and spacious seating for weddings, corporate travel, airport transfers, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Urbania 17 Seater on Rent Near Me Pune",
    description: "Urbania 17 seater on rent near me Pune service provides dependable transportation for family outings, airport transfers, sightseeing tours, weddings, and corporate travel. Spacious interiors and comfortable seating ensure smooth journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient nearby Urbania rental reservations."
  },
  {
    name: "17 Seater Urbania for Outstation Pune",
    description: "17 seater Urbania for outstation Pune service provides premium long-distance transportation for Goa tours, hill station vacations, pilgrimage journeys, and family trips. Spacious seating and smooth highway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "17 Seater Urbania for Family Trip Pune",
    description: "17 seater Urbania for family trip Pune service offers dependable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Spacious seating and comfortable interiors ensure pleasant journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient family trip Urbania reservations."
  },
  {
    name: "17 Seater Urbania for Group Travel Pune",
    description: "17 seater Urbania for group travel Pune service provides spacious transportation for educational tours, sightseeing journeys, office outings, family vacations, and tourist travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient group travel Urbania reservations."
  },
  {
    name: "17 Seater Urbania on Rent Hadapsar",
    description: "17 seater Urbania on rent Hadapsar service offers reliable transportation for corporate travel, family outings, airport transfers, and group journeys. Spacious seating and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient Hadapsar Urbania reservations."
  },
  {
    name: "17 Seater Urbania Hire in Hadapsar",
    description: "17 seater Urbania hire in Hadapsar service provides dependable transportation for sightseeing tours, office travel, weddings, and family vacations. Comfortable seating and luggage space ensure smooth journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hadapsar Pune. Flexible booking options allow convenient Hadapsar Urbania hire reservations."
  },
  {
    name: "17 Seater Urbania on Rent Kharadi",
    description: "17 seater Urbania on rent Kharadi service provides spacious transportation for corporate travel, office outings, airport transfers, and family group travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for IT employees and family passengers. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Kharadi Pune. Flexible booking options allow convenient Kharadi Urbania reservations."
  },
  {
    name: "17 Seater Urbania EON IT Park",
    description: "17 seater Urbania EON IT Park service offers dependable transportation for IT employees, office staff, conferences, airport transfers, and executive travel requirements. Spacious seating and modern interiors ensure smooth journeys suitable for corporate passenger groups. Professional chauffeurs ensure reliable transportation and punctual pickup services throughout the route. Pickup services are available from EON IT Park, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient EON IT Park Urbania reservations."
  },
  {
    name: "17 Seater Urbania on Rent Viman Nagar",
    description: "17 seater Urbania on rent Viman Nagar service provides luxury transportation for airport transfers, weddings, sightseeing tours, and family vacations. Comfortable seating and luggage space ensure pleasant journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, airports, and residential areas across Viman Nagar Pune. Flexible booking options allow convenient Viman Nagar Urbania reservations."
  },
  {
    name: "17 Seater Urbania near Pune Airport",
    description: "17 seater Urbania near Pune Airport service provides dependable transportation for airport transfers, tourist groups, business travelers, and family travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation airport transportation. Professional chauffeurs ensure timely airport pickups and safe driving services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient airport Urbania reservations."
  },
  {
    name: "17 Seater Urbania on Rent Swargate",
    description: "17 seater Urbania on rent Swargate service offers comfortable transportation for family outings, office travel, airport transfers, and sightseeing journeys. Spacious seating and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Swargate Pune. Flexible booking options allow convenient Swargate Urbania reservations."
  },
  {
    name: "17 Seater Urbania Camp Pune",
    description: "17 seater Urbania Camp Pune service provides reliable transportation for tourist travel, business meetings, airport pickups, and family outings. Comfortable seating and luggage capacity ensure smooth journeys suitable for local and intercity passenger movement. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and railway stations across Camp Pune. Flexible booking options allow convenient Camp Urbania reservations."
  },
  {
    name: "17 Seater Urbania on Rent Bibwewadi",
    description: "17 seater Urbania on rent Bibwewadi service offers dependable transportation for weddings, sightseeing tours, office travel, and family vacations. Spacious seating and modern interiors ensure comfortable journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient Bibwewadi Urbania reservations."
  },
  {
    name: "17 Seater Urbania near Dhankawadi",
    description: "17 seater Urbania near Dhankawadi service provides spacious transportation for airport transfers, educational tours, office outings, and family group travel. Comfortable seating and luggage space ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, and residential areas across Dhankawadi Pune. Flexible booking options allow convenient Dhankawadi Urbania reservations."
  },
  {
    name: "17 Seater Urbania on Rent Kothrud",
    description: "17 seater Urbania on rent Kothrud service offers luxury transportation for family vacations, corporate travel, sightseeing journeys, and airport transfers. Spacious seating and premium interiors ensure smooth journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Kothrud Pune. Flexible booking options allow convenient Kothrud Urbania reservations."
  },
  {
    name: "17 Seater Urbania Karve Nagar",
    description: "17 seater Urbania Karve Nagar service provides dependable transportation for weddings, business meetings, airport travel, sightseeing tours, and family group journeys. Comfortable seating and luggage capacity ensure smooth journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Karve Nagar Pune. Flexible booking options allow convenient Karve Nagar Urbania reservations."
  }
],

tableData: [
  ["17 Seater Urbania Traveller Pune", "17 Seater Urbania Hire in Pune"],
  ["17 Seater Urbania Booking Pune", "17 Seater Urbania Van Rental Pune"],
  ["17 Seater Luxury Urbania on Rent Pune", "Urbania 17 Seater on Rent Near Me Pune"],
  ["17 Seater Urbania for Outstation Pune", "17 Seater Urbania for Family Trip Pune"],
  ["17 Seater Urbania for Group Travel Pune", "17 Seater Urbania on Rent Hadapsar"],
  ["17 Seater Urbania Hire in Hadapsar", "17 Seater Urbania on Rent Kharadi"],
  ["17 Seater Urbania EON IT Park", "17 Seater Urbania on Rent Viman Nagar"],
  ["17 Seater Urbania near Pune Airport", "17 Seater Urbania on Rent Swargate"],
  ["17 Seater Urbania Camp Pune", "17 Seater Urbania on Rent Bibwewadi"],
  ["17 Seater Urbania near Dhankawadi", "17 Seater Urbania on Rent Kothrud"],
  ["17 Seater Urbania Karve Nagar", "17 Seater Urbania for Group Travel Pune"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable 17 Seater Urbania on Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 17 seater Urbania rental service in Pune with luxury vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, weddings, and group travel."
      },
      {
        WhyChooseheading: "Affordable 17 Seater Urbania Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 17 seater Urbania on rent in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Urbania Booking Service",
        WhyChoosedescription: "Our 17 seater Force Urbania rental service in Pune operates 24 hours for airport transfers, weddings, outstation tours, pilgrimage trips, corporate outings, and luxury group travel."
      },
      {
        WhyChooseheading: "Comfortable AC Luxury Urbania Vehicles",
        WhyChoosedescription: "All 17 seater Force Urbania vehicles provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for premium and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, sightseeing travel, and multi-day outstation packages according to customer requirements."
      },
      {
        WhyChooseheading: "Perfect for Family & Corporate Group Travel",
        WhyChoosedescription: "Our 17 seater Urbania is ideal for family vacations, office outings, wedding guest transport, airport transfers, picnic tours, and tourist group travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Pune Airport, railway stations, hotels, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Outstation Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation luxury group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 17 seater Urbania on rent in Pune?", answer: "17 seater Urbania rental service in Pune provides luxury group transportation using premium Force Urbania vehicles for family tours, corporate travel, weddings, and outstation journeys." },
    { question: "Is 17 seater Urbania booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 17 seater Force Urbania rental service in Pune." },
    { question: "Is the 17 seater Urbania fully air-conditioned?", answer: "Yes, all 17 seater Force Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book 17 seater Urbania for outstation trips from Pune?", answer: "Yes, customers can book 17 seater Force Urbania for hill stations, pilgrimage tours, holiday trips, destination weddings, and outstation travel from Pune." },
    { question: "Do you provide 17 seater Urbania for corporate events in Pune?", answer: "Yes, Aaradhya Travels provides 17 seater Force Urbania service for office outings, conferences, employee transport, and corporate travel." },
    { question: "Can I book Urbania for weddings and family functions?", answer: "Yes, our 17 seater Urbania vehicles are ideal for wedding guest transportation and family group travel." },
    { question: "Can I book 17 seater Urbania online in Pune?", answer: "Yes, customers can easily book 17 seater Force Urbania rental service online or through phone booking." },
    { question: "Do you provide Pune Airport pickup and drop service?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service using luxury 17 seater Force Urbania vehicles." },
    { question: "Are Urbania rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 17 seater Urbania rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Ranade",
    feedback:
      "For our weekend trip with relatives, we opted for a 17 Seater Urbania on rent in Pune. The premium interiors, ample legroom, and smooth ride made the journey enjoyable for everyone.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Bhave",
    feedback:
      "Traveling with a larger group felt effortless thanks to the 17 Seater Urbania rental in Pune. The vehicle was spotless, highly comfortable, and provided a luxurious experience throughout the trip.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Urbania on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/17-seater-urbania-pune.jpg",
  "description": "Book 17 Seater Urbania on rent in Pune with Aaradhya Travels for luxury group travel, corporate trips, weddings, airport transfers, and outstation journeys. Premium AC luxury van with professional driver service available across Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "12010"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/17-seater-urbania-on-rent-in-pune"
  }
};







  return (
    <div>

<Helmet>
  <title>
    17 Seater Urbania on Rent in Pune | Luxury Van Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 17 Seater Urbania on rent in Pune with Aaradhya Travels. Ideal for corporate travel, weddings, airport transfers, family trips, and outstation journeys with premium luxury seating and professional driver service."
  />

  <meta
    name="keywords"
    content="17 Seater Urbania Traveller Pune, 17 Seater Urbania Hire in Pune, 17 Seater Urbania Booking Pune, 17 Seater Urbania Van Rental Pune, 17 Seater Luxury Urbania on Rent Pune, Urbania 17 Seater on Rent Near Me Pune, 17 Seater Urbania for Outstation Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onesevenurbaniaonrent ;